import { render, staticRenderFns } from "./HealthReport.vue?vue&type=template&id=666a3e74&"
import script from "./HealthReport.vue?vue&type=script&lang=js&"
export * from "./HealthReport.vue?vue&type=script&lang=js&"
import style0 from "./HealthReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports